import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import apiConfig from 'constants/apiConfig';
import { GetIncidentPositionResponse } from 'components/IncidentConfig/incidentConfig.types';

export const keys = {
  base: ['incidentPosition'] as const,
  byIncident: (incidentId: string) => [...keys.base, incidentId] as const,
  byPosition: (incidentId: string, positionId: string) =>
    [...keys.byIncident(incidentId), positionId] as const,
};

export const useGetIncidentPositionInfo = (
  incidentId: string,
  positionId: string,
  onSuccess?: (data: GetIncidentPositionResponse) => void
) => {
  return useQuery({
    queryKey: keys.byPosition(incidentId, positionId),
    queryFn: async () => {
      const response = await axios.get<GetIncidentPositionResponse>(
        `${apiConfig.apiGateway.incidentPositions}/${incidentId}/${positionId}`
      );

      if (onSuccess) {
        onSuccess(response.data);
      }

      return response.data;
    },
    staleTime: 0,
  });
};
